// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"utils_visuallyHidden__SIGvw"};